import React from 'react'
import { Outlet } from 'react-router-dom'
import Header from './Header'
import Sidebar from './Sidebar'
import TrialCountdownBanner from '../billing/TrialCountdownBanner'
import { SidebarProvider, useSidebar } from '../../contexts/SidebarContext'

/**
 * Casca autenticada. O estado da sidebar (drawer, recolhida, peek) vive em
 * SidebarContext para que o editor possa pedir "recolhida enquanto eu existir".
 */
const MainLayout: React.FC = () => (
  <SidebarProvider>
    <MainLayoutShell />
  </SidebarProvider>
)

const MainLayoutShell: React.FC = () => {
  const { openDrawer } = useSidebar()

  return (
    // Altura = viewport DINÂMICO (100dvh) com 100vh de fallback. Em celular,
    // 100vh inclui a área da barra de URL do navegador (iPhone Safari: ~114px),
    // então o pé do layout ficava escondido atrás dela e a barra de abas
    // `fixed bottom-0` do editor mobile cobria o fim do conteúdo rolável.
    // NÃO usar `h-screen h-dvh`: no CSS gerado o Tailwind emite `.h-dvh` ANTES
    // de `.h-screen`, e o 100vh vence. A variante `supports-[…]` sai num bloco
    // @supports depois das utilities simples, então ganha onde dvh existe.
    <div className="flex flex-col h-screen supports-[height:100dvh]:h-dvh bg-cream-100 dark:bg-ink-900 overflow-hidden">
      {/* Banner dentro dos 100vh: fora daqui ele soma altura ao documento, cria
          scrollbar externa e colide com o Header (ambos sticky top-0). */}
      <TrialCountdownBanner />

      <div className="flex flex-1 overflow-hidden">
        <Sidebar />

        <div className="flex-1 flex flex-col overflow-hidden min-w-0">
          <Header onMenuClick={openDrawer} />

          <main className="flex-1 overflow-y-auto">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  )
}

export default MainLayout
